import { UnitConversionDto } from './unitConversion.dto';
import { StockUnitDto } from './stockUnit.dto';
import { RecipeDto } from './recipe.dto';
import { StockDto } from './stock.dto';
import { BaseDto } from './base.dto';
import { OrderServiceTypeDto } from './orderServiceType.dto';

export class DetailContentDto extends BaseDto {

  constructor() 
  {
    super();
  }

  stock?: StockDto;
  stockId?: number;
  bulkRecipe?: RecipeDto;
  bulkRecipeId?: number;
  detailId: number;
  supplier: string;
  category: string;
  name: string;
  supplierCode: string;
  amount: number;
  stockUnit: StockUnitDto;
  orderServiceType: OrderServiceTypeDto;
  cost: number;
  // variable to remember if the detail needs to be added to the DB
  toAdd: boolean;
  toUpdate: boolean;
  unitConversion?: UnitConversionDto;
  active?: boolean;
  orderServiceTypeId?: number;
  // easier variable
  isRecipe: boolean = false;
  effectiveDate?: Date;
}
